<div class="ldt-modal" *transloco="let t; prefix: 'compliance.shared.modals.linkDocumentType'">
  <div class="ldt-modal__header">
    <span>{{ t('title') }}</span>
    <button type="button" class="ldt-modal__close" (click)="cancel()" [attr.aria-label]="'common.close' | transloco">
      <i class="ph ph-x"></i>
    </button>
  </div>

  <div class="ldt-modal__body">
    <p class="ldt-modal__description">
      {{ t('descriptionIntro') }} <strong>{{ t('descriptionExampleDocument') }}</strong> {{ t('descriptionMiddle') }} <strong>{{ t('descriptionExampleRequirement') }}</strong>
    </p>

    <div class="ldt-modal__field">
      <label class="ldt-modal__field-label">{{ t('fieldLabel') }}<span class="ldt-modal__req">*</span></label>
      <div ngbDropdown #documentTypeDropdown="ngbDropdown" class="ldt-modal__dropdown" container="body"
        [autoClose]="'outside'">
        <button
          type="button"
          class="ldt-modal__dropdown-toggle"
          [class.ldt-modal__dropdown-toggle--placeholder]="selectedDocumentTypeId === null"
          [attr.aria-busy]="isLoading"
          ngbDropdownToggle>
          <span class="ldt-modal__dropdown-value">{{ selectedLabel }}</span>
          <i class="ph ph-caret-down"></i>
        </button>
        <div ngbDropdownMenu class="ldt-modal__dropdown-menu">
          @if (isLoading) {
            <div class="ldt-modal__dropdown-status">
              <span class="spinner-border spinner-border-sm" [attr.aria-label]="t('loadingDocumentTypes')"></span>
            </div>
          } @else {
            @for (type of documentTypes; track type.id) {
              @if (getLinkedRequirementName(type); as linkedTo) {
                <button type="button" ngbDropdownItem aria-disabled="true" class="ldt-modal__dropdown-item--linked"
                  (click)="selectDocumentType(type)">
                  <span class="ldt-modal__dropdown-item-name">{{ type.name | lookupLabel:documentTypeLabelPrefix }}</span>
                  <span class="ldt-modal__dropdown-item-linked-to">{{ t('linkedTo', { name: linkedTo }) }}</span>
                </button>
              } @else {
                <button type="button" ngbDropdownItem (click)="selectDocumentType(type); documentTypeDropdown.close()">
                  {{ type.name | lookupLabel:documentTypeLabelPrefix }}
                </button>
              }
            }
          }
        </div>
      </div>
    </div>
  </div>

  <div class="ldt-modal__footer">
    <button type="button" class="ldt-modal__btn-cancel" (click)="cancel()">{{ 'common.cancel' | transloco }}</button>
    <button type="button" class="ldt-modal__btn-save" (click)="save()" [disabled]="isSaveDisabled">{{ t('save') }}</button>
  </div>
</div>
